const UPDATECURRENTSHOPINFO = 'UPDATECURRENTSHOPINFO';
const UPDATEALLSHOPSLIST = 'UPDATEALLSHOPSLIST';

export {
  UPDATECURRENTSHOPINFO,
  UPDATEALLSHOPSLIST,
};
